import { List, OrderedSet } from "immutable";
import memoizeOne from "memoize-one";
import { Item } from "constants/product-collection";
import { AllocationDimensionKind, IAllocationDimension } from "helpers/allocation-dimension";
import { IGridParamsQueryParam } from "./product-collection-views/product-collection-grid-view/tool-panels";

export const getGridParamsFromLocation = ({ query }): IGridParamsQueryParam => {
    let { gridParams } = query;
    try {
        gridParams = JSON.parse(gridParams);
    } catch (e) {
        gridParams = {};
    }

    return gridParams;
};

export const getAllocationDimensionsByKind = memoizeOne(
    (allocationDimensions: IAllocationDimension[], kind: AllocationDimensionKind) => {
        return allocationDimensions.filter((allocationDimension) => allocationDimension.subtype === kind);
    },
);

export const getGenericAllocationDimensions = (allocationDimensions: IAllocationDimension[]) =>
    getAllocationDimensionsByKind(allocationDimensions, AllocationDimensionKind.Generic);
memoizeOne(
    (brands, items: List<any>) => {
        return (
            brands &&
            items
                ?.reduce((acc, item) => acc.add(item.getIn(Item.FIELDS.BRAND_ID)), OrderedSet<string>())
                .map((brandId) => brands?.[brandId])
                .toJS()
        );
    },
    (newArgs, oldArgs) => {
        const [newBrands, newItems] = newArgs;
        const [oldBrands, oldItems] = oldArgs;

        // We don't need new copy if brands are equal and number of items are equal
        return newBrands === oldBrands && newItems?.size === oldItems?.size;
    },
);
